import React, { FC } from "react";
import { get } from "lodash";
import { getLocalstorageToken } from "src/context/AuthHelper";
import {
  NACHWEIS_POSITION_STATUS,
  PLATZHALTER_TEXT,
} from "src/lib/constants/constant";
import { TreeNodeType } from "src/lib/types/types";
import ApplicationHeading from "src/pages/private/online-antrag/application-heading/ApplicationHeading";
import PersonalausgabenLoeweInputMA from "./PersonalausgabenLoeweInputMA";
import PersonalausgabenUebersichtLoeweMA from "./PersonalausgabenUebersichtLoeweMA";
import { getLoeweMittelabrufOrganizations } from "./LoeweMittelabrufOrganizations";

const PersonalausgabenLoeweMA: FC = () => (
  <ApplicationHeading title="Personalausgaben" description={PLATZHALTER_TEXT} />
);

export const getPersonalausgabenLoeweMAChildren = (
  application: any,
): TreeNodeType[] => {
  const applicantOrganizationId = get(getLocalstorageToken(), "organisationId");

  return getLoeweMittelabrufOrganizations(
    application,
    applicantOrganizationId,
  ).map((organization) => ({
    label: organization.label,
    content: (
      <>
        <PersonalausgabenLoeweInputMA
          nachweisPositionStatus={
            NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben
          }
          organizationId={organization.id}
          kostentraeger={organization.kostentraeger}
        />
        <PersonalausgabenLoeweInputMA
          nachweisPositionStatus={NACHWEIS_POSITION_STATUS.geplant}
          organizationId={organization.id}
          kostentraeger={organization.kostentraeger}
        />
      </>
    ),
    showError: false,
  }));
};

export const PersonalausgabenUebersichtParentLoeweMA: FC = () => (
  <ApplicationHeading title="Personalausgaben Übersicht" />
);

export const getPersonalausgabenUebersichtLoeweMAChildren = (
  application: any,
): TreeNodeType[] => {
  const applicantOrganizationId = get(getLocalstorageToken(), "organisationId");

  return getLoeweMittelabrufOrganizations(
    application,
    applicantOrganizationId,
  ).map((organization) => ({
    label: organization.label,
    content: (
          <PersonalausgabenUebersichtLoeweMA
        organizationId={organization.id}
        kostentraeger={organization.kostentraeger}
        hideHeading
      />
    ),
    showError: false,
  }));
};

export default PersonalausgabenLoeweMA;
